import React, { useState, useEffect } from "react";
import * as Menubar from "@radix-ui/react-menubar";
import { Button } from "../ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "../ui/card";
import { Badge } from "../ui/badge";
import { motion } from "framer-motion";
import { User, Settings, LogOut, Edit } from "lucide-react";
import { Input } from "../ui/input";
import { fetchUserProfile } from "@/hooks/useUser";

export default function ProfilePage() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const getProfile = async () => {
      try {
        const userId = localStorage.getItem("userId");
        if (!userId) return;

        const data = await fetchUserProfile(userId);
        setUser(data.user);
      } catch (err) {
        console.error("Error fetching profile:", err);
      } finally {
        setLoading(false);
      }
    };
    getProfile();
  }, []);

  if (loading) return <p className="p-6">Loading...</p>;
  return (
    <div className="min-h-screen flex bg-background p-6">
      <motion.div
        initial={{ opacity: 0, y: 15 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.4 }}
        className="w-full max-w-md"
      >
        <Card className="border rounded-xl shadow-lg">
          <CardHeader className="flex flex-col items-center text-center space-y-3">
            <div className="w-24 h-24 rounded-full bg-muted flex items-center justify-center text-3xl font-bold">
              {user?.name?.charAt(0)}
            </div>
            <CardTitle className="text-lg font-semibold">
              {user?.name}
            </CardTitle>
            <Input placeholder="Name" value={user?.name} disabled />
            <Input placeholder="Email" value={user?.email} disabled />
            <Badge variant="secondary">{user?.role}</Badge>
          </CardHeader>
        </Card>
      </motion.div>
    </div>
  );
}
